import React from "react"
import { RenderElementProps } from "slate-react"

const CopytextFaqIconSmall = ({ children, attributes }: RenderElementProps) => {
    return (
        <p {...attributes} className="mb-4 text-base last:mb-0 sm:mb-5 sm:text-lg">
            {children}
        </p>
    )
}

export default CopytextFaqIconSmall
